import {
  Box,
  Typography,
  ListItem,
  ListItemText,
  Divider,
  Button,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React, { useState } from 'react';

const NotificationCard = ({ notifications, closeNotification }) => {
  const [number, setNumber] = useState(4);

  return (
    <Box
      sx={{
        width: '25rem',
        height: 'auto',
        backgroundColor: 'background.paper',
        position: 'absolute',
        top: '70px',
        right: '230px',
        zIndex: 10,
        borderRadius: '16px',
        border: '1px solid #e0e0e0',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden',
      }}
    >
      <Box sx={{ borderRadius: 4 }}>
        {/* Header */}
        <Box
          sx={{
            p: 2,
            backgroundColor: 'grey.100',
            color: 'text.primary',
            borderBottom: '1px solid #e0e0e0',
            borderRadius: '16px 16px 0 0',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography
            variant="h6"
            gutterBottom
            sx={{ fontWeight: 600, fontSize: '1.2rem', m: 0 }}
          >
            Notification
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 500,
                fontSize: '1rem',
                color: 'primary.main',
                backgroundColor: 'rgba(25, 118, 210, 0.1)',
                px: 1.2,
                py: 0.3,
                borderRadius: '8px',
              }}
            >
              {notifications.length} new
            </Typography>

            {/* Close button */}
            <IconButton
              size="small"
              onClick={() => closeNotification(false)}
              sx={{
                ml: 0.5,
                color: 'text.secondary',
                '&:hover': { backgroundColor: 'grey.200' },
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        </Box>

        {/* Notifications List */}
        <Box
          sx={{
            maxHeight: '25rem',
            overflowY: 'auto',
            backgroundColor: '#fff',
          }}
        >
          {notifications &&
            notifications.length > 0 &&
            notifications.map((notification, index) =>
              index < number ? (
                <React.Fragment key={index}>
                  <ListItem
                    alignItems="flex-start"
                    sx={{
                      px: 2,
                      py: 1.5,
                      '&:hover': { backgroundColor: 'grey.50' },
                    }}
                  >
                    {/* Uncomment below if avatars are needed */}
                    {/* <ListItemAvatar>
                      <Avatar alt="Profile Picture" src={notification.avatar} />
                    </ListItemAvatar> */}
                    <ListItemText
                      primary={
                        <Typography
                          sx={{
                            display: 'block',
                            color: 'text.primary',
                            fontWeight: 500,
                            fontSize: '0.95rem',
                          }}
                        >
                          {notification.message}
                        </Typography>
                      }
                      secondary={
                        <Typography
                          sx={{
                            display: 'block',
                            fontSize: '0.8rem',
                            color: 'text.secondary',
                            mt: 0.5,
                          }}
                        >
                          {notification.time}
                        </Typography>
                      }
                    />
                  </ListItem>
                  <Divider />
                </React.Fragment>
              ) : null
            )}

          {(!notifications || notifications.length === 0) && (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ textAlign: 'center', py: 2 }}
            >
              No new notifications
            </Typography>
          )}
        </Box>

        {/* Footer */}
        {notifications.length ? (
          <Box
            sx={{
              textAlign: 'center',
              p: 1.5,
              backgroundColor: 'grey.50',
              borderTop: '1px solid #e0e0e0',
              borderRadius: '0 0 16px 16px',
            }}
          >
            <Button
              size="small"
              onClick={() => setNumber(notifications.length)}
              sx={{
                color: 'primary.main',
                fontWeight: 600,
                textTransform: 'none',
                fontSize: '0.95rem',
              }}
            >
              See all notifications
            </Button>
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};

export default NotificationCard;
